import { render, staticRenderFns } from "./CardRightPanel.vue?vue&type=template&id=241d09b3&scoped=true&"
import script from "./CardRightPanel.vue?vue&type=script&lang=js&"
export * from "./CardRightPanel.vue?vue&type=script&lang=js&"
import style0 from "./CardRightPanel.vue?vue&type=style&index=0&id=241d09b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241d09b3",
  null
  
)

export default component.exports